/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-20 15:27:00
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-21 11:44:17
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileLibrary/Components/Hint/index.tsx
 */
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
function Hint() {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div>
      <div style={{ marginBottom: '8px', fontWeight: 600 }}>
        {getI18n('settings.list.uploadFileTips')}
      </div>
      <p>
        <span>{getI18n('storeFileLibrary.detail.supportedfileformat')}:</span>
        <br />
        <span>.apng, .jpg, .jpeg, .gif, .png, .svg, .pdf, .mov, .mp4</span>
      </p>
      <p>
        <span>{getI18n('settings.list.maximumuploadfilesize')}:</span>
        <br />
        <span>
          - {getI18n('general.tools_helper.image')}: 20MB - $
          {getI18n('general.tools_helper.video')}: 500MB
        </span>
      </p>
    </div>
  );
}

export default Hint;
